import React, { createContext, useContext, useMemo } from 'react';
import IntelliProveAPI, { AuthenticationMethod } from '~/services/api';

interface iIntelliProveAPIContext {
  children: React.ReactNode;
  apiurl: string;
  authentication: string;
  authenticationMethod?: AuthenticationMethod;
}

// Create a context for the IntelliProveAPI instance, defaulting to null.
const IntelliProveAPIContext = createContext<IntelliProveAPI | null>(null);

export function IntelliProveAPIProvider({
  children,
  apiurl,
  authentication,
  authenticationMethod = AuthenticationMethod.ActionToken,
}: iIntelliProveAPIContext) {
  // useMemo ensures that the API instance is only re-created if dependencies change.
  const intelliProveAPI = useMemo(
    () => new IntelliProveAPI(apiurl, authentication, authenticationMethod),
    [apiurl, authentication, authenticationMethod]
  );

  return <IntelliProveAPIContext.Provider value={intelliProveAPI}>{children}</IntelliProveAPIContext.Provider>;
}

// Custom hook for accessing the IntelliProveAPI instance.
export const useIntelliProveAPI = (): IntelliProveAPI => {
  const context = useContext(IntelliProveAPIContext);
  if (!context) {
    throw new Error('useIntelliProveAPI must be used within an IntelliProveAPIProvider');
  }
  return context;
};
